<template>
  <div>
    <v-data-table
      :loading="loading"
      :search="search"
      :headers="headers"
      :items="domainItems">
      <template v-slot:item.record="{ item }" class="record-cell">
        <template v-if="item.type == 'CAA'">
          <div><b>Flag: </b>{{ item.flag }}</div>
          <div><b>Tag: </b>{{ item.tag }}</div>
          <div><b>Value: </b>{{ item.value }}</div>
        </template>
        <template v-else-if="item.type == 'MX'">
          <div><b>Priority: </b> {{ item.preference }}</div>
          <div class="overflow-x-auto">
            <b>Destination: </b> {{ item.exchange }}
          </div>
        </template>
        <template v-else-if="item.type == 'SRV'">
          <div><b>Priority: </b>{{ item.priority }}</div>
          <div><b>Weight: </b>{{ item.weight }}</div>
          <div><b>Port: </b>{{ item.port }}</div>
          <div><b>Target: </b>{{ item.target }}</div>
        </template>
        <div v-else class="record" v-html="item.record"></div>
      </template>
      <template v-slot:item.actions="{ item }">
        <gg-btn class="mx-1" @click="openEditModal(item)">
          Edit
        </gg-btn>
        <gg-btn class="mx-1" @click="openModal('deleteRecord', item)">
          Delete
        </gg-btn>
      </template>
    </v-data-table>
    <reset-modal :opened="modals.reset"
                 :domain="domain"
                 :username="username"
                 @close="closeModal('reset')"></reset-modal>
    <add-record-modal v-if="modals.addRecord"
                      :opened="modals.addRecord"
                      :domain="selectedItem.domain"
                      :username="username"
                      :type="selectedItem.type"
                      @close="closeModal('addRecord')"
                      @action-completed="reload"></add-record-modal>
    <edit-record-modal v-if="modals.editRecord"
                       :opened="modals.editRecord"
                       :username="username"
                       :item="selectedItem"
                       @close="closeModal('editRecord')"
                       @action-completed="reload"></edit-record-modal>
    <delete-record-modal :opened="modals.deleteRecord"
                         :domain="domain"
                         :username="username"
                         :item="selectedItem"
                         @close="closeModal('deleteRecord')"
                         @action-completed="reload"></delete-record-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import modalsTable from '@/mixins/modalsTable'
import reloadable from '@/mixins/tableShouldBeReloaded'
import ResetModal from './ResetModal'
import AddRecordModal from './AddRecordModal'
import EditRecordModal from './EditRecordModal'
import DeleteRecordModal from './DeleteRecordModal'

export default {
  name: 'DetailsTable',
  components: {
    ResetModal,
    AddRecordModal,
    EditRecordModal,
    DeleteRecordModal,
  },
  mixins: [modalsTable, reloadable],
  props: {
    domain: {
      type: String,
      required: true
    },
    username: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'TTL',
          value: 'ttl'
        },
        {
          text: 'Class',
          value: 'class'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Record',
          cellClass: 'domain-record-cell',
          value: 'record'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      modals: {
        reset: false,
        addRecord: false,
        editRecord: false,
        deleteRecord: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      domain_records: 'hostingDomains/domain_records',
      // resellerZones: 'resellerZones',
    }),
    domainItems () {
      const possibleRecords = ['A', 'AAAA', 'CAA', 'CNAME', 'MX', 'SRV', 'TXT']
      return this.domain_records.filter(item => possibleRecords.includes(item.type))
    }
  },
  methods: {
    ...mapActions({
      getHostingRecords: 'hostingDomains/getHostingRecords',
      reportError: 'reportError'
    }),
    openEditModal (record) {
      let subject = {
        username: this.username || this.$route.query.user,
      }

      switch (record.type) {
        case 'A':
          subject = {
            ...record,
            domain: this.domain,
            address: record.record
          }
          break
        case 'AAAA':
          subject = {
            ...record,
            domain: this.domain,
            address: record.record
          }
          break
        case 'CAA':
          subject = {
            ...record,
            domain: this.domain
          }
          break
        case 'CNAME':
          subject = {
            ...record,
            domain: this.domain,
            cname: record.record
          }
          break
        case 'MX':
          subject = {
            ...record,
            domain: this.domain,
            cname: record.record,
            exchanger: record.exchange,
            priority: record.preference
          }
          break
        case 'SRV':
          subject = {
            ...record,
            domain: this.domain
          }
          break
        case 'TXT':
          subject = {
            ...record,
            domain: this.domain,
            txtdata: record.record
          }
          break
      }
      if (subject.ttl) {
        // prop validation fix
        subject.ttl = subject.ttl.toString()
      }
      this.openModal('editRecord', subject)
    },
    debounceReload: debounce(async function () {
      await this.reload()
    }, 1500, { leading: true, trailing: false }),
    async reload () {
      this.loading = true
      try {
        await this.getHostingRecords({ domain: this.domain, _username: this.username || this.$route.query.user })
        this.$emit('table-reloaded')
      } catch (e) {
        this.reportError(e)
        this.$emit('domain-error')
      } finally {
        this.loading = false
      }
    },
    back () {
      this.$emit('back')
    },
    resetZone () {
      this.openModal('reset', null)
    },
  },
  created () {
    this.reload()
  },
  watch: {
    domain (val) {
      if (val) {
        this.reload()
      }
    }
  }
}
</script>

<style scoped>
.record {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}
</style>
